import { getEnvVariable } from './get-env-variable';

const envToCheckoutUrlMap: Record<string, string> = {
  dev: 'https://checkout-v2-dev.appcharge.com',
  staging: 'https://checkout-v2-staging.appcharge.com',
  sandbox: 'https://checkout-v2-sandbox.appcharge.com',
  production: 'https://checkout-v2.appcharge.com',
}; // need to add this in the CI after cashapp POC

export function getCheckoutUrl() {
  const checkoutUrl = getEnvVariable('REACT_APP_CHECKOUT_URL_FE', process.env.REACT_APP_CHECKOUT_URL_FE);
  const env = getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV);
  return checkoutUrl ?? envToCheckoutUrlMap[env as string];
}
